import { Section, Eyebrow } from "@/components/Primitives";

const sections = [
  ["What we collect", "When you complete an assessment, request a consultation, register for a session, or request the book, we collect the details you provide (such as your name, email, and anything you choose to share) along with your assessment responses and results."],
  ["How we use it", "We use your information to send the results, book, or session links you asked for; to follow up about a consultation you requested; and to improve our content. Assessment data helps us understand which reflections are most helpful."],
  ["Cookies & remarketing", "With your consent, we use cookies for analytics and gentle remarketing (for example, showing relevant information to people who visited our assessments). You can accept, reject, or customize cookies at any time via the banner. Strictly necessary cookies keep the site working."],
  ["Email", "In this launch preview, email delivery is mocked — no real emails are sent yet. When live, we will send only the messages relevant to your request and any follow-up you consented to. You can opt out at any time."],
  ["Data storage & security", "Submissions are stored securely for follow-up. We are not presenting this site as HIPAA-compliant. Please avoid sharing sensitive clinical details through these forms."],
  ["Your choices", "You may request access to, correction of, or deletion of your information by contacting us. You may withdraw email consent at any time."],
];

export default function Privacy() {
  return (
    <div className="pb-8">
      <Section className="pt-14 sm:pt-20 max-w-3xl">
        <Eyebrow>Your privacy matters</Eyebrow>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-stone-900 mt-4">Privacy Policy</h1>
        <p className="text-stone-600 mt-4 leading-relaxed">
          This is a plain-language summary for launch. We keep data collection minimal and use it
          only for what you asked for.
        </p>
        <div className="mt-10 space-y-8">
          {sections.map(([t, d]) => (
            <div key={t} data-testid={`privacy-section-${t.replace(/\s/g, "-").toLowerCase()}`}>
              <h2 className="font-playfair text-2xl text-stone-900">{t}</h2>
              <p className="text-stone-600 mt-2 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-stone-500 mt-10">
          This summary is provided for the launch and does not constitute legal advice. Final legal
          wording should be reviewed by qualified counsel.
        </p>
      </Section>
    </div>
  );
}
